module.exports = __webpack_public_path__ + "img/xspaybg.62afc4ad.png";